import * as React from "react";
import { Doc } from "@repo/convex/convex/_generated/dataModel";
import { ChatMessageContent } from "./ChatMessageContent.tsx";

interface Props {
  message: Doc<"itemChatMessages">;
}

/** The AI's answers on the left beside the chest, what you asked on the right. */
export const MessageAndAvatarRow: React.FC<Props> = ({ message }) => {
  if (message.speaker == "assistant")
    return (
      <div className="chat-row">
        <img className="chat-avatar" src="/logo.webp" alt="" />
        <div className="chat-bubble chat-bubble-ai">
          <ChatMessageContent message={message} />
        </div>
      </div>
    );

  return (
    <div className="chat-row chat-row-me">
      <div className="chat-bubble chat-bubble-me">
        <ChatMessageContent message={message} />
      </div>
    </div>
  );
};
